import { render } from "./LwPanel.vue?vue&type=template&id=55aae824&scoped=true"
import script from "./LwPanel.vue?vue&type=script&lang=js"
export * from "./LwPanel.vue?vue&type=script&lang=js"

import "./LwPanel.vue?vue&type=style&index=0&id=55aae824&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aae824"]])

export default __exports__